import React, { useState } from 'react';
import { Form, Input, Button, Typography, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';
import { authService } from '../services/authService';
import logo from '../assets/logo-pvs-profitpanels.png';

const { Title, Text } = Typography;
//test changes
const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      await authService.login(values.username, values.password);

      notification.success({
        message: 'Login Successful',
        description: 'Welcome to PVS PROFITPANELS ERP'
      });

      // Small delay to ensure local storage and state are settled 
      setTimeout(() => {
        navigate('/');
      }, 500);

    } catch (error) {
      notification.error({
        message: 'Login Failed',
        description: error.error || 'Invalid credentials'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f5f7fa',
      padding: '20px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: 420,
        background: '#ffffff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        padding: '48px 40px',
      }}>
        {/* Logo/Header Section */}
        <div style={{
          textAlign: 'center',
          marginBottom: '40px',
          borderBottom: '1px solid #f0f0f0',
          paddingBottom: '32px'
        }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '80px',
            height: '80px',
            marginBottom: '20px',
          }}>
            <img
              src={logo}
              alt="Profit Panels Logo"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain'
              }}
            />
          </div>
          <Title level={3} style={{
            margin: 0,
            marginBottom: '8px',
            color: '#1a1a1a',
            fontWeight: 600,
            fontSize: '24px'
          }}>
            PVS PROFITPANELS ERP
          </Title>
          <Text type="secondary" style={{ fontSize: '14px' }}>
            Sign in to continue to your account
          </Text>
        </div>

        {/* Form Section */}
        <Form
          name="login"
          onFinish={onFinish}
          layout="vertical"
          size="large"
          requiredMark={false}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Please enter your username' }]}
            style={{ marginBottom: '24px' }}
          >
            <Input
              prefix={<UserOutlined style={{ color: '#8c8c8c' }} />}
              placeholder="Username"
              autoComplete="username"
              style={{
                height: '44px',
                fontSize: '14px',
                borderRadius: '6px'
              }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please enter your password' }]}
            style={{ marginBottom: '32px' }}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#8c8c8c' }} />}
              placeholder="Password"
              autoComplete="current-password"
              style={{
                height: '44px',
                fontSize: '14px',
                borderRadius: '6px'
              }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: '24px' }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
              style={{
                height: '44px',
                fontSize: '15px',
                fontWeight: 500,
                borderRadius: '6px',
                boxShadow: '0 2px 4px rgba(24, 144, 255, 0.2)'
              }}
            >
              Sign In
            </Button>
          </Form.Item>
        </Form>

        {/* Footer Section */}
        <div style={{
          textAlign: 'center',
          marginTop: '32px',
          paddingTop: '24px',
          borderTop: '1px solid #f0f0f0'
        }}>
          {/* Demo credentials info removed for live app */}
          <div style={{ marginTop: '8px' }}>
            <Text type="secondary" style={{ fontSize: '10px', opacity: 0.6, letterSpacing: '0.5px' }}>
              BUILD Production Environment
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
